document.addEventListener('DOMContentLoaded', function () {
  var button = document.querySelector('[data-mobile-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (button && nav) {
    button.addEventListener('click', function () {
      nav.hidden = !nav.hidden;
      button.setAttribute('aria-expanded', String(!nav.hidden));
    });
  }
});

document.addEventListener('change', function (event) {
  var languageSelector = event.target.closest('[data-language-selector]');
  if (languageSelector && languageSelector.form) {
    languageSelector.form.submit();
    return;
  }

  var variantSelector = event.target.closest('[data-variant-selector]');
  if (!variantSelector) return;

  var productRoot = variantSelector.closest('[data-product-root]');
  if (!productRoot) return;

  var option = variantSelector.options[variantSelector.selectedIndex];
  var price = productRoot.querySelector('[data-product-price]');
  var addButton = productRoot.querySelector('[data-add-to-cart]');
  var isAvailable = option && option.dataset.available === 'true';

  if (price && option && option.dataset.price) {
    price.textContent = option.dataset.price;
  }

  if (addButton) {
    addButton.disabled = !isAvailable;
    addButton.textContent = isAvailable ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
  }
});

/* Judge.me cleanup for product reviews */
(function () {
  function cleanJudgeMeReviews(root) {
    if (!root) return;

    root.querySelectorAll('*').forEach(function (el) {
      if (el.children.length) return;
      var text = (el.textContent || '').trim().replace(/\s+/g, ' ');
      if (/^Avis Clients?$/i.test(text) || /^Customer Reviews?$/i.test(text) || /^Aucun élément trouvé$/i.test(text) || /^No items found$/i.test(text)) {
        el.style.setProperty('display', 'none', 'important');
      }

      if (/^Écrire un avis$/i.test(text) || /^Write a review$/i.test(text)) {
        var reviewButton = el.closest('a,button') || el;
        reviewButton.style.setProperty('background', '#111', 'important');
        reviewButton.style.setProperty('border', '1px solid #111', 'important');
        reviewButton.style.setProperty('color', '#fff', 'important');
        reviewButton.style.setProperty('border-radius', '0', 'important');
        reviewButton.style.setProperty('box-shadow', 'none', 'important');
        reviewButton.style.setProperty('letter-spacing', '.08em', 'important');
        reviewButton.style.setProperty('text-transform', 'uppercase', 'important');
        reviewButton.style.setProperty('padding', '.85rem 1.35rem', 'important');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.product-reviews');
    if (!root) return;

    cleanJudgeMeReviews(root);
    new MutationObserver(function () { cleanJudgeMeReviews(root); }).observe(root, { childList: true, subtree: true });
    setTimeout(function () { cleanJudgeMeReviews(root); }, 800);
    setTimeout(function () { cleanJudgeMeReviews(root); }, 2000);
  });
})();
